import { render, staticRenderFns } from "./RouteNotFound.vue?vue&type=template&id=05862752&"
import script from "./RouteNotFound.vue?vue&type=script&lang=js&"
export * from "./RouteNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports